var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/sms"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.583 20.0218H6.41634C3.07051 20.0218 1.14551 18.0968 1.14551 14.751V8.33431C1.14551 4.98848 3.07051 3.06348 6.41634 3.06348H15.583C18.9288 3.06348 20.8538 4.98848 20.8538 8.33431V14.751C20.8538 18.0968 18.9288 20.0218 15.583 20.0218ZM6.41634 4.43848C3.79467 4.43848 2.52051 5.71264 2.52051 8.33431V14.751C2.52051 17.3726 3.79467 18.6468 6.41634 18.6468H15.583C18.2047 18.6468 19.4788 17.3726 19.4788 14.751V8.33431C19.4788 5.71264 18.2047 4.43848 15.583 4.43848H6.41634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9999 12.3399C10.2299 12.3399 9.45071 12.1016 8.85488 11.6158L5.98571 9.32412C5.69238 9.08579 5.63738 8.65495 5.87571 8.36162C6.11405 8.06829 6.54488 8.01329 6.83822 8.25162L9.70737 10.5433C10.404 11.1025 11.5865 11.1025 12.2832 10.5433L15.1524 8.25162C15.4457 8.01329 15.8857 8.05912 16.1149 8.36162C16.3532 8.65495 16.3074 9.09495 16.0049 9.32412L13.1357 11.6158C12.549 12.1016 11.7699 12.3399 10.9999 12.3399Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms2);
export default __webpack_public_path__ + "static/media/sms_2.6cfa9c966181adde2d21438eead20a5d.svg";
export { ForwardRef as ReactComponent };